import template from './user-ratings.html';
import userRatingsController from './user-ratings.controller';
import './user-ratings.styl';

let userRatingsComponent = {
  restrict: 'E',
  bindings: {
    userId: '<',
    userType: '<',
    onRatingUpdated: '&',
  },
  template,
  controller: userRatingsController,
  controllerAs: 'vm'
};

export default userRatingsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-ratings/user-ratings.component.js
 **/